import React, { FunctionComponent } from 'react';
import Translate from 'ui/atoms/translate';
import { hideCentralCharacters } from 'ui/helper/hideCharacters';
import PlaceholderFallback from 'ui/atoms/placeholder-fallback';
import Currency from 'ui/atoms/currency';
import { Money } from 'api';
import Date from 'ui/atoms/date';
import CardItem from 'src/ui/atoms/card-item';

export interface StudioInvestmentTaxDataProps {
  taxInformation: {
    taxIdentificationNumber?: string;
    exemptionOrderSum?: Money | null;
    exemptionOrderDate?: Date | null;
  };
}

const StudioInvestmentTaxData: FunctionComponent<StudioInvestmentTaxDataProps> = (props) => {
  const { taxInformation } = props;

  return (
    <>
      <CardItem
        title={<Translate name="studioInvestmentTaxData.taxNumber" />}
        content={
          <PlaceholderFallback>
            {taxInformation?.taxIdentificationNumber &&
              hideCentralCharacters(taxInformation.taxIdentificationNumber, 2, -2)}
          </PlaceholderFallback>
        }
      />
      <CardItem
        title={<Translate name="studioInvestmentTaxData.exemptionOrderAmount" />}
        content={
          <PlaceholderFallback>
            {taxInformation?.exemptionOrderSum && <Currency>{taxInformation.exemptionOrderSum}</Currency>}
          </PlaceholderFallback>
        }
      />
      <CardItem
        title={<Translate name="studioInvestmentTaxData.lastChangeExemptionOrder" />}
        content={
          <PlaceholderFallback>
            {taxInformation?.exemptionOrderDate && <Date>{taxInformation.exemptionOrderDate}</Date>}
          </PlaceholderFallback>
        }
      />
    </>
  );
};

export default StudioInvestmentTaxData;
